import React from 'react';
import { observer } from 'mobx-react';

import { Button, Dialog } from '@material-ui/core';

import '../../styles/PopUp.scss';

const styles = {
  popupstyle: {
    width: '100%',
  },
  popupTitle: {
    width: '100%',
  },
  iconStyle: {
    alignSelf: 'center',
    marginRight: '10px',
  },
  panelStyle: {
    marginTop: '15px',
  },
};

const PopUp = observer(
  class PopupSolicitudCanceladaComponent extends React.Component {
    hide = () => {
      if (this.props.onCerrar) {
        this.props.onCerrar();
      }
    };

    getTexto = () => {
      return <p id="txtModal">Has desistido de la contratación de los productos ofertados de portabilidad financiera. Te estaremos esperando en caso de querer realizar una nueva solicitud.</p>;
    };

    render() {
      const texto = this.getTexto();
      return (
        <Dialog id="modal" modal="true" open={this.props.open} style={styles.popupstyle}>
          <div className="Panel" style={styles.panelStyle}>
            <div className="titlePopup">
              <div id="txtTituloModal" style={styles.popupTitle}>
                Solicitud de Portabilidad Cancelada
              </div>
            </div>
            <div className="boxMensaje">
              <div className="mensaje">{texto}</div>
              <div className="boxButton">
                <Button id="btnPopUp" variant="contained" color="primary" onClick={this.hide} className="btn-moradoModal" fullWidth={true}>
                  aceptar
                </Button>
              </div>
            </div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      );
    }
  }
);

//const PopUp = withStyles(styles)(PopUpMandatoComponent);
export default PopUp;
